import { Observable } from 'rxjs';
import { AlarmLite } from '../../model/alarm/alarm-lite';
import { Alarm } from '../../model/alarm/alarm';
import { DataModel } from '@infodata-group/inf-commons';
import { AlarmUpdateDto } from '../../dto/alarm/alarm-update.dto';
import { VigiHttpFilter } from '../../modules/shared/engine/vigi-http-filter';

export abstract class AlarmGateway {
  abstract get$(httpFilter?: VigiHttpFilter): Observable<Alarm[]>;
  abstract getLite$(): Observable<AlarmLite[]>;
  abstract options$(): Observable<DataModel>;
  abstract update$(dto: AlarmUpdateDto): Observable<any>;
}
